import { CSSProperties } from 'react';
import theme, { shade } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  selected?: boolean;
  dragging?: boolean;
  isConnectable?: boolean;
}

export const selectedColor = '#ffc300';
export const leafRoutineColor = theme.palette.success.dark;
export const combinationalLogicColor = theme.palette.primary.dark;
export const finiteStateMachineColor = shade(theme.palette.secondary.main, -20);
export const scheduleColor = shade(theme.palette.charts.primary.orange, -40);

const baseStyles = ({ selected, dragging, isConnectable }: IProps): CSSProperties => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'center',
  minWidth: 100,
  maxWidth: 200,
  minHeight: 50,
  backgroundColor: leafRoutineColor,
  color: theme.palette.primary.contrastText,
  border: `${selected ? 3 : 1}px solid ${
    selected ? selectedColor : theme.palette.primary.contrastText
  }`,
  borderRadius: '10%',
  padding: 10,
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '& .react-flow__handle': {
    width: '30px',
    height: '14px',
    borderRadius: '3px',
    backgroundColor: !isConnectable
      ? theme.palette.action.disabled
      : theme.palette.background.paper,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '& .react-flow__handle-top': {
    top: '-10px',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '& .react-flow__handle-bottom': {
    bottom: '-10px',
  },
});

const useStyles = makeStyles<IProps>()((theme, props) => ({
  routine: {
    ...baseStyles(props),
    borderRadius: '50%',
  },
  combinationalLogic: {
    ...baseStyles(props),
    backgroundColor: combinationalLogicColor,
  },
  finiteStateMachine: {
    ...baseStyles(props),
    backgroundColor: finiteStateMachineColor,
  },
  schedule: {
    ...baseStyles(props),
    backgroundColor: scheduleColor,
  },
  machineElement: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '& .react-flow__handle': {
      width: '14px',
      height: '14px',
      borderRadius: '50%',
    },
  },
}));

export default useStyles;
